import React from 'react';
import List from './List';

const AllList = ({ ...props }) => (
  <List
    url="installer-orders"
    title="All Orders"
    showCompletedAt={true}
    canManage={true}
    canChangeStatus={true}
    showOrderStatus={true}
    hideByDefault={true}
    canView={true}
    {...props}
  />
);

export default AllList;


// WEBPACK FOOTER //
// ./src/pages/InstallerOrders/AllList.js